<template>
    <ModalTemplate
        :show="show"
        :headless="true"
        :close-button="false"
        @close="$emit('close')"
        width="max-w-lg w-full"
        padding="p-0"
    >
        <div class="bg-white rounded-lg p-8 max-h-[90dvh] overflow-y-auto">
            <Transition name="fade" mode="out-in">
                <div>
                    <h4
                        v-if="isEditing"
                        v-text="this.$lang.get('Edit title')"
                        class="mb-4"
                    />
                    <h4
                        v-else
                        v-text="this.$lang.get('Create title')"
                        class="mb-4"
                    />
                    <TextInput
                        v-model="form.name"
                        :label="$lang.get('Title')"
                        :description="
                            $lang.get(
                                'A title is a way to organize resources in the sidebar. After the title is created you can add resources to it.'
                            )
                        "
                        id="title"
                        size="md"
                        class="mb-1.5"
                        required
                    />

                    <PrimaryButton
                        @click="submit"
                        :disabled="!canSubmit"
                        v-text="$lang.get('Save')"
                    />
                </div>
            </Transition>
        </div>
    </ModalTemplate>
</template>

<script>
import ModalTemplate from '@/Components/Templates/ModalTemplate.vue'
import {
    PhUser,
    PhImage,
    PhPlus,
    PhX,
    PhMagnifyingGlass,
    PhArrowRight,
} from '@phosphor-icons/vue'
import TextInput from '@/Components/FormElements/TextInput.vue'
import TextAreaInput from '@/Components/FormElements/TextAreaInput.vue'
import UrlScraper from '@/Components/Elements/UrlScraper.vue'
import PrimaryButton from '@/Components/Elements/PrimaryButton.vue'
import DropZone from '@/Components/Elements/DropZone.vue'
import { getImageAsBase64 } from '@/Tools/utilities'
import ReactiveHeightTransition from '@/Components/Transitions/ReactiveHeightTransition.vue'
import { useForm } from '@inertiajs/vue3'

export default {
    name: 'RightColumnGroupModal',
    components: {
        PhUser,
        PhImage,
        PhPlus,
        PhX,
        PhMagnifyingGlass,
        PhArrowRight,

        ModalTemplate,
        TextInput,
        PrimaryButton,
    },

    emits: ['close'],

    props: {
        show: {
            type: Boolean,
            required: true,
        },
        model: {
            type: Object,
            required: true,
        },
        modelClass: {
            type: String,
            required: true,
        },
        id: {
            type: Number,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            form: useForm({
                name: this.name ?? '',
                id: this.id ?? null,
                modelName: this.modelClass,
                modelId: this.model?.id ?? null,
            }),
        }
    },

    computed: {
        canSubmit() {
            return this.form.name.length > 3 && this.form.name.length < 50
        },
    },

    methods: {
        isEditing() {
            return this.name !== ''
        },

        submit() {
            this.form.post(route('resource.rightcolumngroup'), {
                onSuccess: (response) => {
                    this.$emit('close')
                },
            })
        },
    },
}
</script>
